﻿import React from 'react';

import { getEpiData } from '../../../Utils/epiHelpers';

// animation files
import awardAnimData from '../../../AnimationFiles/award.json';
import cakeAnimData from '../../../AnimationFiles/cake.json';

//animation components
import Animation from './Animations/Animation';
import HeroSection from './Animations/HeroSection';
import FooterSection from './Animations/FooterSection';
import CheckmarkContainer from '../../../Features/UspAnimation/CheckmarkContainer';

//text components
import GenericText from './Texts/GenericText';


const EmployerBrandingPage = (props) => {

    const headingHero = getEpiData('heading-hero', props.mountRootId) || '';
    const subtextHero = getEpiData('subtext-hero', props.mountRootId) || '';
    const buttonTextHero = getEpiData('buttontext-hero', props.mountRootId) || '';
    const buttonLinkHero = getEpiData('buttonlink-hero', props.mountRootId) || '';

    const heading1 = getEpiData('heading-1', props.mountRootId) || '';
    const subtext1 = getEpiData('subtext-1', props.mountRootId) || '';

    const heading2 = getEpiData('heading-2', props.mountRootId) || '';
    const subtext2 = getEpiData('subtext-2', props.mountRootId) || '';


    const headingFooter = getEpiData('heading-footer', props.mountRootId) || '';
    const textFooter = getEpiData('text-footer', props.mountRootId) || '';
    const subtextFooter = getEpiData('subtext-footer', props.mountRootId) || '';
    const buttonTextFooter = getEpiData('buttontext-footer', props.mountRootId) || '';
    const buttonLinkFooter = getEpiData('buttonlink-footer', props.mountRootId) || '';


    const uspheading1 = getEpiData('usp-heading-1', props.mountRootId) || '';
    const uspsubtext1 = getEpiData('usp-subtext-1', props.mountRootId) || '';
    const uspheading2 = getEpiData('usp-heading-2', props.mountRootId) || '';
    const uspsubtext2 = getEpiData('usp-subtext-2', props.mountRootId) || '';
    const uspheading3 = getEpiData('usp-heading-3', props.mountRootId) || '';
    const uspsubtext3 = getEpiData('usp-subtext-3', props.mountRootId) || '';

    const headings = [uspheading1, uspheading2, uspheading3];
    const texts = [uspsubtext1, uspsubtext2, uspsubtext3];

    return (
        <div className="employer-branding">
            <HeroSection
                heading={headingHero}
                text={subtextHero}
                buttonLink={buttonLinkHero}
                buttonText={buttonTextHero}
            />

            <section className="employer-branding__usp">
                <CheckmarkContainer headings={headings} texts={texts} class={'employer-branding__usp__container'} />
            </section>

            <section className="employer-branding__section text-on-left">
                <GenericText heading={heading1} text={subtext1} />
                <Animation animationData={awardAnimData} />
            </section>

            <section className="employer-branding__section">
                <Animation animationData={cakeAnimData} />
                <GenericText heading={heading2} text={subtext2} />
            </section>


            <FooterSection
                heading={headingFooter}
                text1={textFooter}
                text2={subtextFooter}
                buttonLink={buttonLinkFooter}
                buttonText={buttonTextFooter}
            />
        </div>
        )
}
              
export default EmployerBrandingPage;


